import React from "react";
import loginWall from "../Image/404-style-15.jpg";
import "../component/css/ErrorPage.css";

function ErrorPage() {
  const handleNavigate = () => {
    window.location.href = "/app/#/user-Machines";
  };
  return (
    <div style={{ textAlign: "justify", backgroundColor: "#000C30" }}>
      <img onClick={handleNavigate} src={loginWall} className="error-page" />
    </div>
  );
}

export default ErrorPage;
